import Axios from "axios";
import {
    SET_EMPLOYEE_SALARY_HISTORY_REPORT_LIST, 
    UNSET_EMPLOYEE_SALARY_HISTORY_REPORT_LIST
} from "@/store/mutation-types";
import {
    getemployeeSalaryHistoryReport,
} from "@/store/api";

const state = {
    getemployeeSalaryHistoryReport: [],
};

const getters = {
    getemployeeSalaryHistoryReport(state) {
        return state.getemployeeSalaryHistoryReport;
    },
};

const mutations = {
    [SET_EMPLOYEE_SALARY_HISTORY_REPORT_LIST](state, data) {
        state.getemployeeSalaryHistoryReport = data;
    },
    [UNSET_EMPLOYEE_SALARY_HISTORY_REPORT_LIST](state) {
        state.getemployeeSalaryHistoryReport = [];
    },
};

const actions = {

    getemployeeSalaryHistoryReport({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`${getemployeeSalaryHistoryReport}`, { params: data })
                .then((response) => {
                    commit(SET_EMPLOYEE_SALARY_HISTORY_REPORT_LIST, response.data.data );
                    resolve(response);
                })
                .catch((error) => {
                    commit(UNSET_EMPLOYEE_SALARY_HISTORY_REPORT_LIST);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
    

};


export default {
    state,
    getters,
    actions,
    mutations,
};